import React, { useEffect, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import useExpiresTimer from '../../hooks/useExpiresTimer';
import { setModalShown } from '../../store/actions/ProjectActions';
import { showModal } from '../../store/actions/AssessmentActions';
import { useTranslation } from 'react-i18next';

const ExpiresTimer = ({ expiresAt, assessmentId, handleSubmit }) => {
  const dispatch = useDispatch();
  const { assessment, error, modalShown } = useSelector(state => state.project);
  const { show, name: currentModalName } = useSelector(state => state.modal);
  const { t } = useTranslation('project_container');
  const remaining = useExpiresTimer(expiresAt);
  const expiredAssessmentsRef = useRef(new Set());

  useEffect(() => {
    // Only check expiration if remaining has been calculated (not null)
    if (
      remaining !== null &&
      remaining <= 0 &&
      expiresAt &&
      !expiredAssessmentsRef.current.has(assessmentId) &&
      !modalShown
    ) {
      expiredAssessmentsRef.current.add(assessmentId);
      console.log('remaining', remaining, 'Calling dispatch', show, currentModalName);

      // Call submitAssessment to update assessment status to 'submitted'
      if (
        assessmentId &&
        assessment?.status === 'in_progress' &&
        !error &&
        !(show && currentModalName === 'time_up_info')
      ) {
        // Show time up modal only if it's not already visible and hasn't been shown before
        dispatch(setModalShown(true));
        dispatch(
          showModal({
            name: 'time_up_info',
            type: 'info',
            title: t('time_up_title'),
            content: t('time_up_content'),
            onOk: async () => {
              // Submit the project using the handleSubmit prop
              await handleSubmit();
            },
            onCancel: async () => {
              // Submit the project using the handleSubmit prop
              await handleSubmit();
            },
          }),
        );
      }
    }
  }, [
    remaining,
    expiresAt,
    assessmentId,
    dispatch,
    error,
    assessment?.status,
    show,
    currentModalName,
    modalShown,
    handleSubmit,
  ]);

  if (!expiresAt || remaining === null) {
    return <span style={{ color: 'white', fontSize: '36px' }}>00:00:00</span>;
  }

  const hours = Math.floor(remaining / (1000 * 60 * 60));
  const minutes = Math.floor((remaining % (1000 * 60 * 60)) / (1000 * 60));
  const seconds = Math.floor((remaining % (1000 * 60)) / 1000);

  const format = num => (num < 10 ? `0${num}` : num);

  const displayTime = `${format(hours)}:${format(minutes)}:${format(seconds)}`;

  return <span style={{ color: 'white', fontSize: '36px' }}>{displayTime}</span>;
};

export default ExpiresTimer;
